import Dinero from 'dinero.js';
import { Order } from '../../../../../../clients/quipli-service/order/order';
import { safeRound } from '../../../../../../util/util';
import { HourOverageOverride } from '../../../shared/hooks/use-hour-overage-calculation';

export const OffRentAdHocAndOverrages = ({
  order,
  adhocLineItems,
  currency,
  hourOverageOverrides,
  hourOverageTax,
}: {
  order: Order;
  adhocLineItems: any[]; // These are LineItem[], but need explicit typing
  currency: Dinero.Currency | undefined;
  hourOverageOverrides: HourOverageOverride[];
  hourOverageTax: Dinero.Dinero | undefined;
}) => {
  return (
    <>
      {!order.isCycleBilled &&
        adhocLineItems.map((li) => {
          return (
            <>
              <div key={`${li.id}-1`} className="col-span-3 items-center gap-2">
                {li.name}
              </div>
              <div key={`${li.id}-4`} className="flex items-center">
                {Dinero({
                  amount: safeRound(li.total * 100),
                  currency,
                }).toFormat()}
              </div>
              <div key={`${li.id}-5`} className="flex flex-row items-center gap-2"></div>
              <div key={`${li.id}-6`} className="flex flex-row items-center gap-2">
                {Dinero({
                  amount: safeRound(li.total * 100),
                  currency,
                }).toFormat()}
              </div>
            </>
          );
        })}
      {!order.isCycleBilled && hourOverageOverrides && hourOverageOverrides.some((ov) => ov.overageCharge > 0) && (
        <>
          <div className="col-span-3">Hour Overage Tax</div>
          <div className="col-start-5">{hourOverageTax?.toFormat()}</div>
          <div />
        </>
      )}
    </>
  );
};
